import { _getMessageListContainer, _trackScrollToBottomOfMessagesEventWithThrottle } from '../util/screenListeners';
import { extractSelectedTicketIdFromState, hasMessageBeenRead } from '../extractFromState';

const SCROLL_THRESHOLD = 0.1;

export const scrollRequirementMet = () => (dispatch, getState) => {
  const ticketId = extractSelectedTicketIdFromState(getState());
  dispatch({
    type: 'SCROLL_REQUIREMENT_MET',
    ticketId,
  });
};

export const initializeMessageScrollListener = () => (dispatch) => {
  const messageListContainer = _getMessageListContainer();
  if (messageListContainer) {
    messageListContainer.addEventListener('scroll', getHandleScrollListener(dispatch));
  }
};

const _handleMessageContainerScroll =
  ({ target }) =>
  (dispatch, getState) => {
    // check to see if we have scrolled to close to the bottom
    const distFrombottom = target.scrollHeight - (target.scrollTop + target.offsetHeight);
    // want to check if the top offset is much larger than the distance from the bottom
    const closeToBottom = target.offsetHeight * SCROLL_THRESHOLD > distFrombottom;
    const hasBeenRead = hasMessageBeenRead(getState());
    if (closeToBottom && !hasBeenRead) {
      dispatch(scrollRequirementMet());
      _trackScrollToBottomOfMessagesEventWithThrottle();
    }
  };

export const removeMessageScrollListener = () => (dispatch) => {
  const messageListContainer = _getMessageListContainer();
  handleScrollListener &&
    messageListContainer &&
    messageListContainer.removeEventListener('scroll', handleScrollListener);
};

export const scrollEventListener = (dispatch) => (target) => dispatch(_handleMessageContainerScroll(target));

let handleScrollListener;

const getHandleScrollListener = (dispatch) => {
  if (!handleScrollListener) {
    handleScrollListener = scrollEventListener(dispatch);
  }

  return handleScrollListener;
};
